<template>
  <div>
    <pull-refresh v-model="refreshing" @refresh="onRefresh">
      <list
        class="cont-box"
        v-model="loading"
        @load="getlistdata"
        :finished="finished"
        finished-text="没有更多了"
      >
        <div
          class="item-box"
          @click="toDetail(item)"
          v-for="item in list"
          :key="item.id"
        >
          <!-- <div class="item-box"> -->
          <div class="item-left" :class="{ 'item-left-red': listType === '2' }">
            {{ listType === '2' ? '人力' : taskSourceMap[item.taskSource] }}
          </div>
          <div class="item-center">
            <div class="item-title">
              <span class="title-name van-ellipsis">{{
                listType === '2' ? item.noticeTitle : item.processName
              }}</span>
              <div v-if="active == 'todo'">
                <span class="title-tag title-tag-error">{{
                  listType === '2'
                    ? item.statusStr
                    : item.taskType
                    ? statusMap[item.taskType].text
                    : '待处理'
                }}</span>
              </div>
              <div v-else>
                <span
                  class="title-tag"
                  :class="
                    item.formData && item.formData.reject == 'true'
                      ? 'title-tag-error'
                      : 'title-tag-success'
                  "
                  v-if="item.taskType == 1"
                >
                  {{
                    listType === '2'
                      ? item.statusStr
                      : item.formData && item.formData.reject == 'true'
                      ? '审批不通过'
                      : '审批通过'
                  }}
                </span>
                <span class="title-tag title-tag-success" v-else>{{
                  listType === '2'
                    ? item.statusStr
                    : statusMap[item.taskType].text
                }}</span>
              </div>
              <span class="title-time">{{
                item.createTime.split(' ')[0]
              }}</span>
            </div>
            <div class="item-content van-ellipsis">
              {{ listType === '2' ? item.noticeContent : item.taskName }}
            </div>
            <div class="item-subcontent">
              {{
                listType === '2'
                  ? '发起人：' + (item.createName || '无')
                  : '滞留时间：' + item.durationInMillis
              }}
            </div>
          </div>
          <icon class="item-right-icon" name="arrow" />
        </div>
      </list>
    </pull-refresh>
  </div>
</template>

<script>
import { Cell, Icon, List, PullRefresh } from 'vant'
import application from '@api/application'
import user from '../../../store/modules/user'

export default {
  name: 'messterList',
  components: {
    Cell,
    List,
    Icon,
    PullRefresh,
  },
  props: {
    // 事项类型：todo 待办；done 已办
    active: {
      type: String,
      default() {
        return 'todo'
      },
    },
    // 办理类型：1 审批；2 业务
    listType: {
      type: String,
      default() {
        return 1
      },
    },
  },
  data() {
    return {
      title: this.$route.query.title,
      key: this.$route.query.key,
      token: sessionStorage.getItem('token'),
      projectId: this.$store.state.project.projectId,
      statusMap: {
        1: { text: '待审批', status: 'warning' },
        2: { text: '待处理', status: 'processing' },
        3: { text: '待签名', status: 'processing' },
      },
      taskSourceMap: {
        0: '工程',
        1: '设计',
        2: '安全',
        3: '质量',
        4: '物资',
        5: '法务',
        6: '办公',
        7: '科技',
        8: '技术',
        9: '工会',
        10: '商务',
        11: '纪检',
        12: '车辆',
        13: '党群'
      },
      query: {
        pageNo: 1,
        pageSize: 7,
        users: [],
      },

      list: [],
      error: false,
      loading: false,
      finished: false,
      refreshing: false,
      columns: [],
      screen: this.$route.query.screen,
      qualityquery: this.$store.state.project.qualityquery,
    }
  },
  created() {
    // if (this.$store.state.project.key === 0) {
    //
    // }  else if (this.$store.state.project.key === 1){
    //
    // }
  },
  watch: {
    active(val, oldVal) {
      if (val) {
        this.list = []
        this.onRefresh()
      }
    },
    listType(val, oldVal) {
      if (val) {
        this.list = []
        this.onRefresh()
      }
    },
  },
  computed: {
    currentList() {
      return this.active
    },
    userInfo() {
      return localStorage.getItem('vuex')
        ? JSON.parse(localStorage.getItem('vuex')).user.userInfo
        : {}
    },
    posts() {
      return localStorage.getItem('vuex')
        ? JSON.parse(localStorage.getItem('vuex')).user.userInfo.posts
        : []
    },
    postIds() {
      const userList = [this.userInfo.userId],
        postsId =
          (this.posts && this.posts.length && this.posts.map((i) => i.id)) || []
      if (postsId && postsId.length) {
        userList.push(...postsId)
      }
      return userList
    },
    users() {
      JSON.parse(localStorage.getItem('vuex')).user.userInfo.userId
      const userList =
        (this.userInfo &&
          this.userInfo.posts &&
          this.userInfo.posts.map((item) => item.id)) ||
        []

      userList.push(this.userInfo.userId)
      return userList
    },
  },
  methods: {
    getlistdata(type = 'add') {
      if (this.refreshing) {
        this.list = []
        this.refreshing = false
      }
      if (type == 'new') {
        this.list = []
        this.query.pageNo = 1
        this.loading = true
        this.finished = false
      }
      this.listType == 1
        ? this.currentList === 'todo'
          ? this.getTodoList()
          : this.getDownList()
        : this.getPageSysNotice()
    },
    getDownList() {
      this.query.users = this.users
      application
        .getDownList(this.query)
        .then((res) => {
          if (res.code === 200) {
            res.data.map((d) => {
              if (d.formData) {
                d.formData = JSON.parse(d.formData)
              }
            })
            this.list = this.list.concat(res.data)
            this.query.pageNo++
            this.loading = false
            if (this.list.length == res.totalSize) {
              this.finished = true
            }
          } else {
            this.loading = false
            this.finished = true
          }
          this.error = true
        })
        .catch((err) => {
          this.loading = false
          this.finished = true
          this.error = true
        })
    },
    /**
     * @description: 获取业务列表，status：0 待办；1 已办；sources：2 人力资源类型
     */
    getPageSysNotice() {
      let args = {
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        query: {
          receiverId: this.userInfo?.userId,
          sources: 2,
          status: this.currentList === 'todo' ? 0 : 1,
        },
      }
      application
        .getPageSysNotice(args)
        .then((res) => {
          if (res.code === 200) {
            this.list = this.list.concat(res.data)
            this.currentList === 'todo' &&
              this.$store.commit(
                'messageInfo/SET_TODOCOUNTBUSSINESS',
                Number(res.totalSize)
              )
            this.query.pageNo++
            this.loading = false
            if (this.list.length == res.totalSize) {
              this.finished = true
            }
          } else {
            this.loading = false
            this.finished = true
          }
          this.error = true
        })
        .catch((err) => {
          this.loading = false
          this.finished = true
          this.error = true
        })
    },
    getTodoList() {
      this.query.users = this.postIds
      application
        .getTodoList(this.query)
        .then((res) => {
          if (res.code == 200) {
            this.list = this.list.concat(res.data)
            this.$store.commit(
              'messageInfo/SET_TODOCOUNT',
              Number(res.totalSize)
            )
            this.query.pageNo++
            this.loading = false
            if (res.currentPage >= res.totalPage) {
              this.finished = true
            }
          } else {
            this.error = true
            this.loading = false
            this.finished = true
          }
        })
        .catch((err) => {
          this.error = true
          this.loading = false
          this.finished = true
        })
    },
    searchLoad() {
      this.getlistdata('new')
    },
    onRefresh() {
      this.getlistdata('new')
      this.finished = false
      this.loading = true
    },
    toDetail(val) {
      // 若是办理类型为业务且业务类型是人力资源
      if (this.listType === '2' && val.sources === 2) {
        // 拼接全访问链接
        let url = 'https://hr.cscecxn.com' + val.url + '&token=' + this.token
        this.$router.push({
          path: '/webView',
          query: {
            webUrl: url,
            webTitle: '业务详情',
            goHistory: 1,
          },
        })
        return
      }
      if (!val.businessId) {
        this.$error({ content: '无有效业务ID，请刷新数据重试！' })
        return
      }
      const query = {
        active: this.currentList,
        taskDefKey: val.taskDefKey,
        businessType: val.businessType,
        businessId: val.businessId,
        id: val.businessId,
        procInstId: val.procInstId,
        name: encodeURIComponent(val.taskName),
        processName: encodeURIComponent(val.processName),
        taskId: val.taskId,
      }
      if (val.formData && val.formData.opinions != '') {
        query['opinions'] = val.formData.opinions
      }
      if (val.detailUrl) {
        query['detailUrl'] = encodeURIComponent(val.detailUrl)
      }
      if (val.assignee) {
        query['assignee'] = val.assignee
      }
      let auditRouter = val.taskMobileUrl || '/application/process/audit'

      //若链接带isAudit=1则跳转pc审批页面
      if(auditRouter.indexOf('isAudit=1') !== -1){
        let url = `https://pm.cscecxn.com${auditRouter}&access_token=${this.token}&businessType=${val.businessType}&businessId=${val.businessId}&id=${val.businessId}&procInstId=${val.procInstId}&taskId=${val.taskId}&active=${this.currentList}&taskDefKey=${val.taskDefKey}&name=${encodeURIComponent(val.taskName)}&processName=${encodeURIComponent(val.processName)}`
        this.$router.push({
          path: '/webView',
          query: {
            webUrl: url,
            webTitle: '业务审批',
            goHistory: 1,
          },
        })
        return
      }
     this.$router.push({
        path: auditRouter,
        query,
      })
    },
  },
  mounted() {
    // if(this.screen) {
    //     Object.assign(this.query.query, this.$store.state.project.qualityquery);
    // }
    // project.qualitytype({query:{labelType: '3'}}).then(res=> {
    //     if(res.code === 200){
    //         this.approvallist = [{name:'全部',id:''}].concat(res.data);
    //     }else {
    //         this.$toast(res.message)
    //     }
    // });
  },
}
</script>

<style lang="scss" scoped>
.view {
  .content {
    padding-bottom: 50px;
    .cont-box {
      padding: 1rem;
      .item-box {
        display: flex;
        align-items: center;
        margin-bottom: 1rem;
        overflow: hidden;
        line-height: 2.4rem;
        min-height: 7rem;
        font-size: 1.4rem;
        position: relative;
        &:active {
          background-color: #f2f3f5;
        }
        &::after {
          right: 0 !important;
          left: 0 !important;
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          right: 1.6rem;
          bottom: 0;
          left: 1.6rem;
          border-bottom: 0.1rem solid #ebedf0;
          -webkit-transform: scaleY(0.5);
          transform: scaleY(0.5);
        }
        .item-left {
          width: 4rem;
          height: 4rem;
          line-height: 4rem;
          text-align: center;
          color: #fff;
          font-size: 1.6rem;
          border-radius: 100%;
          background: #277ed0;
          box-shadow: 0 0 0 0.8rem rgba(39, 126, 208, 0.5);
          margin-right: 1.8rem;
          margin-left: 0.8rem;
        }
        .item-left-red {
          background: #ec808d;
          box-shadow: 0 0 0 0.8rem rgba(249, 218, 222);
        }
        .item-center {
          flex: 1;
          overflow: hidden;
          .item-title {
            display: flex;
            .title-name {
              font-size: 1.6rem;
              flex: 1;
            }
            .title-tag {
              border-radius: 4px;
              font-size: 1.2rem;
              line-height: 2.4rem;
              padding: 0 0.6rem;
              margin-right: 1rem;
              height: 2.4rem;
            }
            .title-tag-success {
              color: #02a7f0;
              border: 1px solid #02a7f0;
              background: #02a7f019;
            }
            .title-tag-error {
              color: #f5222d;
              border: 1px solid #ffa39e;
              background: #fef0ef;
            }
            .title-time {
              text-align: right;
              color: #999;
            }
          }
          .item-content {
            color: #999;
          }
          .item-subcontent {
            color: #999;
            font-size: 1.2rem;
          }
        }
        .item-right-icon {
          margin-left: 0.4rem;
          color: #969799;
        }
      }
    }
  }
}
</style>
